import React from 'react';

function DTOTraining() {
  return <></>;
}
export default DTOTraining;
